<div class="customizer-setting d-none d-md-block">
	<div
		class="btn-info btn-rounded shadow-lg btn btn-icon btn-lg p-2"
		data-bs-toggle="offcanvas"
		data-bs-target="#theme-settings-offcanvas"
		aria-controls="theme-settings-offcanvas"
		(click)="toggleRightSidebar()"
	>
		<i class="mdi mdi-spin mdi-cog-outline fs-22"></i>
	</div>
</div>

<!-- Theme Settings -->
<div
	class="offcanvas offcanvas-end border-0"
	tabindex="-1"
	id="theme-settings-offcanvas"
>
	<div
		class="d-flex align-items-center bg-primary bg-gradient p-3 offcanvas-header"
	>
		<h5 class="m-0 me-2 text-white">Theme Customizer</h5>

		<button
			type="button"
			class="btn-close btn-close-white ms-auto"
			data-bs-dismiss="offcanvas"
			aria-label="Close"
			(click)="hide()"
		></button>
	</div>
	<div class="offcanvas-body p-0">
		<ngx-simplebar class="h-100">
			<div class="p-4">
				<!-- <h6 class="mb-0 fw-semibold text-uppercase">Layout</h6>
                <p class="text-muted">Choose your layout</p>

                <div class="row">
                    <div class="col-4">
                        <div class="form-check card-radio">
                            <input id="customizer-layout01" name="data-layout" type="radio" value="vertical"
                                class="form-check-input" (click)="changeLayout('vertical')">
                            <label class="form-check-label p-0 avatar-md w-100" for="customizer-layout01">
                                <span class="d-flex gap-1 h-100">
                                    <span class="flex-shrink-0">
                                        <span class="bg-light d-flex h-100 flex-column gap-1 p-1">
                                            <span class="d-block p-1 px-2 bg-soft-primary rounded mb-2"></span>
                                            <span class="d-block p-1 px-2 pb-0 bg-soft-primary"></span>
                                            <span class="d-block p-1 px-2 pb-0 bg-soft-primary"></span>
                                            <span class="d-block p-1 px-2 pb-0 bg-soft-primary"></span>
                                        </span>
                                    </span>
                                    <span class="flex-grow-1">
                                        <span class="d-flex h-100 flex-column">
                                            <span class="bg-light d-block p-1"></span>
                                            <span class="bg-light d-block p-1 mt-auto"></span>
                                        </span>
                                    </span>
                                </span>
                            </label>
                        </div>
                        <h5 class="fs-13 text-center mt-2">Vertical</h5>
                    </div>
                    <div class="col-4">
                        <div class="form-check card-radio">
                            <input id="customizer-layout02" name="data-layout" type="radio" value="horizontal"
                                class="form-check-input"  (click)="changeLayout('horizontal')">
                            <label class="form-check-label p-0 avatar-md w-100" for="customizer-layout02">
                                <span class="d-flex h-100 flex-column gap-1">
                                    <span class="bg-light d-flex p-1 gap-1 align-items-center">
                                        <span class="d-block p-1 bg-soft-primary rounded me-1"></span>
                                        <span class="d-block p-1 pb-0 px-2 bg-soft-primary ms-auto"></span>
                                        <span class="d-block p-1 pb-0 px-2 bg-soft-primary"></span>
                                    </span>
                                    <span class="bg-light d-block p-1"></span>
                                    <span class="bg-light d-block p-1 mt-auto"></span>
                                </span>
                            </label>
                        </div>
                        <h5 class="fs-13 text-center mt-2">Horizontal</h5>
                    </div>
                    <div class="col-4">
                        <div class="form-check card-radio">
                            <input id="customizer-layout03" name="data-layout" type="radio" value="twocolumn"
                                class="form-check-input" (click)="changeLayout('twocolumn')">
                            <label class="form-check-label p-0 avatar-md w-100" for="customizer-layout03">
                                <span class="d-flex gap-1 h-100">
                                    <span class="flex-shrink-0">
                                        <span class="bg-light d-flex h-100 flex-column gap-1">
                                            <span class="d-block p-1 bg-soft-primary mb-2"></span>
                                            <span class="d-block p-1 pb-0 bg-soft-primary"></span>
                                            <span class="d-block p-1 pb-0 bg-soft-primary"></span>
                                            <span class="d-block p-1 pb-0 bg-soft-primary"></span>
                                        </span>
                                    </span>
                                    <span class="flex-shrink-0">
                                        <span class="bg-light d-flex h-100 flex-column gap-1 p-1">
                                            <span class="d-block p-1 px-2 pb-0 bg-soft-primary"></span>
                                            <span class="d-block p-1 px-2 pb-0 bg-soft-primary"></span>
                                            <span class="d-block p-1 px-2 pb-0 bg-soft-primary"></span>
                                            <span class="d-block p-1 px-2 pb-0 bg-soft-primary"></span>
                                        </span>
                                    </span>
                                    <span class="flex-grow-1">
                                        <span class="d-flex h-100 flex-column">
                                            <span class="bg-light d-block p-1"></span>
                                            <span class="bg-light d-block p-1 mt-auto"></span>
                                        </span>
                                    </span>
                                </span>
                            </label>
                        </div>
                        <h5 class="fs-13 text-center mt-2">Two Column</h5>
                    </div>
                    -- end col --
                </div> -->

				<h6 class="mt-4 mb-0 fw-semibold text-uppercase">
					Color Scheme
				</h6>
				<p class="text-muted">Choose Light or Dark Scheme.</p>
				<div class="colorscheme-cardradio">
					<div class="row">
						<div class="col-4">
							<div class="form-check card-radio">
								<input
									class="form-check-input"
									type="radio"
									name="data-layout-mode"
									id="layout-mode-light"
									value="light"
									[checked]="mode === 'light'"
									onchange="document.documentElement.setAttribute('data-layout-mode', 'light')"
								/>
								<label
									class="form-check-label p-0 avatar-md w-100"
									for="layout-mode-light"
								>
									<span class="d-flex gap-1 h-100">
										<span class="flex-shrink-0">
											<span
												class="bg-light d-flex h-100 flex-column gap-1 p-1"
											>
												<span
													class="d-block p-1 px-2 bg-soft-primary rounded mb-2"
												></span>
												<span
													class="d-block p-1 px-2 pb-0 bg-soft-primary"
												></span>
												<span
													class="d-block p-1 px-2 pb-0 bg-soft-primary"
												></span>
												<span
													class="d-block p-1 px-2 pb-0 bg-soft-primary"
												></span>
											</span>
										</span>
										<span class="flex-grow-1">
											<span
												class="d-flex h-100 flex-column"
											>
												<span
													class="bg-light d-block p-1"
												></span>
												<span
													class="bg-light d-block p-1 mt-auto"
												></span>
											</span>
										</span>
									</span>
								</label>
							</div>
							<h5 class="fs-13 text-center mt-2">Light</h5>
						</div>

						<div class="col-4">
							<div class="form-check card-radio dark">
								<input
									class="form-check-input"
									type="radio"
									name="data-layout-mode"
									id="layout-mode-dark"
									value="dark"
									[checked]="mode === 'dark'"
									onchange="document.documentElement.setAttribute('data-layout-mode', 'dark')"
								/>
								<label
									class="form-check-label p-0 avatar-md w-100 bg-dark"
									for="layout-mode-dark"
								>
									<span class="d-flex gap-1 h-100">
										<span class="flex-shrink-0">
											<span
												class="bg-soft-light d-flex h-100 flex-column gap-1 p-1"
											>
												<span
													class="d-block p-1 px-2 bg-soft-light rounded mb-2"
												></span>
												<span
													class="d-block p-1 px-2 pb-0 bg-soft-light"
												></span>
												<span
													class="d-block p-1 px-2 pb-0 bg-soft-light"
												></span>
												<span
													class="d-block p-1 px-2 pb-0 bg-soft-light"
												></span>
											</span>
										</span>
										<span class="flex-grow-1">
											<span
												class="d-flex h-100 flex-column"
											>
												<span
													class="bg-soft-light d-block p-1"
												></span>
												<span
													class="bg-soft-light d-block p-1 mt-auto"
												></span>
											</span>
										</span>
									</span>
								</label>
							</div>
							<h5 class="fs-13 text-center mt-2">Dark</h5>
						</div>
					</div>
				</div>

				<ng-template
					[ngIf]="
						attribute === 'vertical' || attribute === 'horizontal'
					"
				>
					<div id="layout-width">
						<h6 class="mt-4 mb-0 fw-semibold text-uppercase">
							Layout Width
						</h6>
						<p class="text-muted">Choose Fluid or Boxed layout.</p>

						<div class="row">
							<div class="col-4">
								<div class="form-check card-radio">
									<input
										class="form-check-input"
										type="radio"
										name="data-layout-width"
										id="layout-width-fluid"
										value="fluid"
										[checked]="width === 'fluid'"
										onchange="document.documentElement.setAttribute('data-layout-width', 'fluid'), document.documentElement.setAttribute('data-sidebar-size', 'lg')"
									/>
									<label
										class="form-check-label p-0 avatar-md w-100"
										for="layout-width-fluid"
									>
										<span class="d-flex gap-1 h-100">
											<span class="flex-shrink-0">
												<span
													class="bg-light d-flex h-100 flex-column gap-1 p-1"
												>
													<span
														class="d-block p-1 px-2 bg-soft-primary rounded mb-2"
													></span>
													<span
														class="d-block p-1 px-2 pb-0 bg-soft-primary"
													></span>
													<span
														class="d-block p-1 px-2 pb-0 bg-soft-primary"
													></span>
													<span
														class="d-block p-1 px-2 pb-0 bg-soft-primary"
													></span>
												</span>
											</span>
											<span class="flex-grow-1">
												<span
													class="d-flex h-100 flex-column"
												>
													<span
														class="bg-light d-block p-1"
													></span>
													<span
														class="bg-light d-block p-1 mt-auto"
													></span>
												</span>
											</span>
										</span>
									</label>
								</div>
								<h5 class="fs-13 text-center mt-2">Fluid</h5>
							</div>
							<div class="col-4">
								<div class="form-check card-radio">
									<input
										class="form-check-input"
										type="radio"
										name="data-layout-width"
										id="layout-width-boxed"
										value="boxed"
										[checked]="width === 'boxed'"
										onchange="document.documentElement.setAttribute('data-layout-width', 'boxed'), document.documentElement.setAttribute('data-sidebar-size', 'sm-hover')"
									/>
									<label
										class="form-check-label p-0 avatar-md w-100 px-2"
										for="layout-width-boxed"
									>
										<span
											class="d-flex gap-1 h-100 border-start border-end"
										>
											<span class="flex-shrink-0">
												<span
													class="bg-light d-flex h-100 flex-column gap-1 p-1"
												>
													<span
														class="d-block p-1 px-2 bg-soft-primary rounded mb-2"
													></span>
													<span
														class="d-block p-1 px-2 pb-0 bg-soft-primary"
													></span>
													<span
														class="d-block p-1 px-2 pb-0 bg-soft-primary"
													></span>
													<span
														class="d-block p-1 px-2 pb-0 bg-soft-primary"
													></span>
												</span>
											</span>
											<span class="flex-grow-1">
												<span
													class="d-flex h-100 flex-column"
												>
													<span
														class="bg-light d-block p-1"
													></span>
													<span
														class="bg-light d-block p-1 mt-auto"
													></span>
												</span>
											</span>
										</span>
									</label>
								</div>
								<h5 class="fs-13 text-center mt-2">Boxed</h5>
							</div>
						</div>
					</div>
				</ng-template>

				<ng-template
					[ngIf]="
						attribute === 'vertical' || attribute === 'horizontal'
					"
				>
					<div id="layout-position">
						<h6 class="mt-4 mb-0 fw-semibold text-uppercase">
							Layout Position
						</h6>
						<p class="text-muted">
							Choose Fixed or Scrollable Layout Position.
						</p>

						<div class="btn-group radio" role="group">
							<input
								type="radio"
								class="btn-check"
								name="data-layout-position"
								id="layout-position-fixed"
								value="fixed"
								[checked]="position === 'fixed'"
								onchange="document.documentElement.setAttribute('data-layout-position', 'fixed')"
							/>
							<label
								class="btn btn-light w-sm"
								for="layout-position-fixed"
								>Fixed</label
							>

							<input
								type="radio"
								class="btn-check"
								name="data-layout-position"
								id="layout-position-scrollable"
								value="scrollable"
								[checked]="position === 'scrollable'"
								onchange="document.documentElement.setAttribute('data-layout-position', 'scrollable')"
							/>
							<label
								class="btn btn-light w-sm ms-0"
								for="layout-position-scrollable"
								>Scrollable</label
							>
						</div>
					</div>
				</ng-template>

				<h6 class="mt-4 mb-0 fw-semibold text-uppercase">
					Topbar Color
				</h6>
				<p class="text-muted">Choose Light or Dark Topbar Color.</p>

				<div class="row">
					<div class="col-4">
						<div class="form-check card-radio">
							<input
								class="form-check-input"
								type="radio"
								name="data-topbar"
								id="topbar-color-light"
								value="light"
								[checked]="topbar === 'light'"
								onchange="document.documentElement.setAttribute('data-topbar', 'light')"
							/>
							<label
								class="form-check-label p-0 avatar-md w-100"
								for="topbar-color-light"
							>
								<span class="d-flex gap-1 h-100">
									<span class="flex-shrink-0">
										<span
											class="bg-light d-flex h-100 flex-column gap-1 p-1"
										>
											<span
												class="d-block p-1 px-2 bg-soft-primary rounded mb-2"
											></span>
											<span
												class="d-block p-1 px-2 pb-0 bg-soft-primary"
											></span>
											<span
												class="d-block p-1 px-2 pb-0 bg-soft-primary"
											></span>
											<span
												class="d-block p-1 px-2 pb-0 bg-soft-primary"
											></span>
										</span>
									</span>
									<span class="flex-grow-1">
										<span class="d-flex h-100 flex-column">
											<span
												class="bg-light d-block p-1"
											></span>
											<span
												class="bg-light d-block p-1 mt-auto"
											></span>
										</span>
									</span>
								</span>
							</label>
						</div>
						<h5 class="fs-13 text-center mt-2">Light</h5>
					</div>
					<div class="col-4">
						<div class="form-check card-radio">
							<input
								class="form-check-input"
								type="radio"
								name="data-topbar"
								id="topbar-color-dark"
								value="dark"
								[checked]="topbar === 'dark'"
								onchange="document.documentElement.setAttribute('data-topbar', 'dark')"
							/>
							<label
								class="form-check-label p-0 avatar-md w-100"
								for="topbar-color-dark"
							>
								<span class="d-flex gap-1 h-100">
									<span class="flex-shrink-0">
										<span
											class="bg-light d-flex h-100 flex-column gap-1 p-1"
										>
											<span
												class="d-block p-1 px-2 bg-soft-primary rounded mb-2"
											></span>
											<span
												class="d-block p-1 px-2 pb-0 bg-soft-primary"
											></span>
											<span
												class="d-block p-1 px-2 pb-0 bg-soft-primary"
											></span>
											<span
												class="d-block p-1 px-2 pb-0 bg-soft-primary"
											></span>
										</span>
									</span>
									<span class="flex-grow-1">
										<span class="d-flex h-100 flex-column">
											<span
												class="bg-primary d-block p-1"
											></span>
											<span
												class="bg-light d-block p-1 mt-auto"
											></span>
										</span>
									</span>
								</span>
							</label>
						</div>
						<h5 class="fs-13 text-center mt-2">Dark</h5>
					</div>
				</div>

				<ng-template [ngIf]="attribute === 'vertical'">
					<div id="sidebar-size">
						<h6 class="mt-4 mb-0 fw-semibold text-uppercase">
							Sidebar Size
						</h6>
						<p class="text-muted">Choose a size of Sidebar.</p>

						<div class="row">
							<div class="col-4">
								<div
									class="form-check sidebar-setting card-radio"
								>
									<input
										class="form-check-input"
										type="radio"
										name="data-sidebar-size"
										id="sidebar-size-default"
										value="lg"
										[checked]="size === 'lg'"
										onchange="document.documentElement.setAttribute('data-sidebar-size', 'lg')"
									/>
									<label
										class="form-check-label p-0 avatar-md w-100"
										for="sidebar-size-default"
									>
										<span class="d-flex gap-1 h-100">
											<span class="flex-shrink-0">
												<span
													class="bg-light d-flex h-100 flex-column gap-1 p-1"
												>
													<span
														class="d-block p-1 px-2 bg-soft-primary rounded mb-2"
													></span>
													<span
														class="d-block p-1 px-2 pb-0 bg-soft-primary"
													></span>
													<span
														class="d-block p-1 px-2 pb-0 bg-soft-primary"
													></span>
													<span
														class="d-block p-1 px-2 pb-0 bg-soft-primary"
													></span>
												</span>
											</span>
											<span class="flex-grow-1">
												<span
													class="d-flex h-100 flex-column"
												>
													<span
														class="bg-light d-block p-1"
													></span>
													<span
														class="bg-light d-block p-1 mt-auto"
													></span>
												</span>
											</span>
										</span>
									</label>
								</div>
								<h5 class="fs-13 text-center mt-2">Default</h5>
							</div>

							<div class="col-4">
								<div
									class="form-check sidebar-setting card-radio"
								>
									<input
										class="form-check-input"
										type="radio"
										name="data-sidebar-size"
										id="sidebar-size-compact"
										value="md"
										[checked]="size === 'md'"
										onchange="document.documentElement.setAttribute('data-sidebar-size', 'md')"
									/>
									<label
										class="form-check-label p-0 avatar-md w-100"
										for="sidebar-size-compact"
									>
										<span class="d-flex gap-1 h-100">
											<span class="flex-shrink-0">
												<span
													class="bg-light d-flex h-100 flex-column gap-1 p-1"
												>
													<span
														class="d-block p-1 bg-soft-primary rounded mb-2"
													></span>
													<span
														class="d-block p-1 pb-0 bg-soft-primary"
													></span>
													<span
														class="d-block p-1 pb-0 bg-soft-primary"
													></span>
													<span
														class="d-block p-1 pb-0 bg-soft-primary"
													></span>
												</span>
											</span>
											<span class="flex-grow-1">
												<span
													class="d-flex h-100 flex-column"
												>
													<span
														class="bg-light d-block p-1"
													></span>
													<span
														class="bg-light d-block p-1 mt-auto"
													></span>
												</span>
											</span>
										</span>
									</label>
								</div>
								<h5 class="fs-13 text-center mt-2">Compact</h5>
							</div>

							<div class="col-4">
								<div
									class="form-check sidebar-setting card-radio"
								>
									<input
										class="form-check-input"
										type="radio"
										name="data-sidebar-size"
										id="sidebar-size-small"
										value="sm"
										[checked]="size === 'sm'"
										onchange="document.documentElement.setAttribute('data-sidebar-size', 'sm')"
									/>
									<label
										class="form-check-label p-0 avatar-md w-100"
										for="sidebar-size-small"
									>
										<span class="d-flex gap-1 h-100">
											<span class="flex-shrink-0">
												<span
													class="bg-light d-flex h-100 flex-column gap-1"
												>
													<span
														class="d-block p-1 bg-soft-primary mb-2"
													></span>
													<span
														class="d-block p-1 pb-0 bg-soft-primary"
													></span>
													<span
														class="d-block p-1 pb-0 bg-soft-primary"
													></span>
													<span
														class="d-block p-1 pb-0 bg-soft-primary"
													></span>
												</span>
											</span>
											<span class="flex-grow-1">
												<span
													class="d-flex h-100 flex-column"
												>
													<span
														class="bg-light d-block p-1"
													></span>
													<span
														class="bg-light d-block p-1 mt-auto"
													></span>
												</span>
											</span>
										</span>
									</label>
								</div>
								<h5 class="fs-13 text-center mt-2">
									Small (Icon View)
								</h5>
							</div>

							<div class="col-4">
								<div
									class="form-check sidebar-setting card-radio"
								>
									<input
										class="form-check-input"
										type="radio"
										name="data-sidebar-size"
										id="sidebar-size-small-hover"
										value="sm-hover"
										[checked]="size === 'sm-hover'"
										onchange="document.documentElement.setAttribute('data-sidebar-size', 'sm-hover')"
									/>
									<label
										class="form-check-label p-0 avatar-md w-100"
										for="sidebar-size-small-hover"
									>
										<span class="d-flex gap-1 h-100">
											<span class="flex-shrink-0">
												<span
													class="bg-light d-flex h-100 flex-column gap-1"
												>
													<span
														class="d-block p-1 bg-soft-primary mb-2"
													></span>
													<span
														class="d-block p-1 pb-0 bg-soft-primary"
													></span>
													<span
														class="d-block p-1 pb-0 bg-soft-primary"
													></span>
													<span
														class="d-block p-1 pb-0 bg-soft-primary"
													></span>
												</span>
											</span>
											<span class="flex-grow-1">
												<span
													class="d-flex h-100 flex-column"
												>
													<span
														class="bg-light d-block p-1"
													></span>
													<span
														class="bg-light d-block p-1 mt-auto"
													></span>
												</span>
											</span>
										</span>
									</label>
								</div>
								<h5 class="fs-13 text-center mt-2">
									Small Hover View
								</h5>
							</div>
						</div>
					</div>
				</ng-template>
				<ng-template [ngIf]="attribute === 'vertical'">
					<div id="sidebar-view">
						<h6 class="mt-4 mb-0 fw-semibold text-uppercase">
							Sidebar View
						</h6>
						<p class="text-muted">
							Choose Default or Detached Sidebar view.
						</p>

						<div class="row">
							<div class="col-4">
								<div
									class="form-check sidebar-setting card-radio"
								>
									<input
										class="form-check-input"
										type="radio"
										name="data-layout-style"
										id="sidebar-view-default"
										value="default"
										[checked]="sidebarView === 'default'"
										onchange="document.documentElement.setAttribute('data-layout-style', 'default')"
									/>
									<label
										class="form-check-label p-0 avatar-md w-100"
										for="sidebar-view-default"
									>
										<span class="d-flex gap-1 h-100">
											<span class="flex-shrink-0">
												<span
													class="bg-light d-flex h-100 flex-column gap-1 p-1"
												>
													<span
														class="d-block p-1 px-2 bg-soft-primary rounded mb-2"
													></span>
													<span
														class="d-block p-1 px-2 pb-0 bg-soft-primary"
													></span>
													<span
														class="d-block p-1 px-2 pb-0 bg-soft-primary"
													></span>
													<span
														class="d-block p-1 px-2 pb-0 bg-soft-primary"
													></span>
												</span>
											</span>
											<span class="flex-grow-1">
												<span
													class="d-flex h-100 flex-column"
												>
													<span
														class="bg-light d-block p-1"
													></span>
													<span
														class="bg-light d-block p-1 mt-auto"
													></span>
												</span>
											</span>
										</span>
									</label>
								</div>
								<h5 class="fs-13 text-center mt-2">Default</h5>
							</div>
							<div class="col-4">
								<div
									class="form-check sidebar-setting card-radio"
								>
									<input
										class="form-check-input"
										type="radio"
										name="data-layout-style"
										id="sidebar-view-detached"
										value="detached"
										[checked]="sidebarView === 'detached'"
										onchange="document.documentElement.setAttribute('data-layout-style', 'detached')"
									/>
									<label
										class="form-check-label p-0 avatar-md w-100"
										for="sidebar-view-detached"
									>
										<span class="d-flex h-100 flex-column">
											<span
												class="bg-light d-flex p-1 gap-1 align-items-center px-2"
											>
												<span
													class="d-block p-1 bg-soft-primary rounded me-1"
												></span>
												<span
													class="d-block p-1 pb-0 px-2 bg-soft-primary ms-auto"
												></span>
												<span
													class="d-block p-1 pb-0 px-2 bg-soft-primary"
												></span>
											</span>
											<span
												class="d-flex gap-1 h-100 p-1 px-2"
											>
												<span class="flex-shrink-0">
													<span
														class="bg-light d-flex h-100 flex-column gap-1 p-1"
													>
														<span
															class="d-block p-1 px-2 pb-0 bg-soft-primary"
														></span>
														<span
															class="d-block p-1 px-2 pb-0 bg-soft-primary"
														></span>
														<span
															class="d-block p-1 px-2 pb-0 bg-soft-primary"
														></span>
													</span>
												</span>
											</span>
											<span
												class="bg-light d-block p-1 mt-auto px-2"
											></span>
										</span>
									</label>
								</div>
								<h5 class="fs-13 text-center mt-2">Detached</h5>
							</div>
						</div>
					</div>
				</ng-template>
				<ng-template
					[ngIf]="
						attribute === 'vertical' || attribute === 'twocolumn'
					"
				>
					<div id="sidebar-color">
						<h6 class="mt-4 mb-0 fw-semibold text-uppercase">
							Sidebar Color
						</h6>
						<p class="text-muted">
							Choose Ligth or Dark Sidebar Color.
						</p>

						<div class="row">
							<div class="col-4">
								<div
									class="form-check sidebar-setting card-radio"
								>
									<input
										class="form-check-input"
										type="radio"
										name="data-sidebar"
										id="sidebar-color-light"
										value="light"
										[checked]="sidebar === 'light'"
										onchange="document.documentElement.setAttribute('data-sidebar', 'light')"
										(click)="removeActive()"
									/>
									<label
										class="form-check-label p-0 avatar-md w-100"
										for="sidebar-color-light"
									>
										<span class="d-flex gap-1 h-100">
											<span class="flex-shrink-0">
												<span
													class="bg-white border-end d-flex h-100 flex-column gap-1 p-1"
												>
													<span
														class="d-block p-1 px-2 bg-soft-primary rounded mb-2"
													></span>
													<span
														class="d-block p-1 px-2 pb-0 bg-soft-primary"
													></span>
													<span
														class="d-block p-1 px-2 pb-0 bg-soft-primary"
													></span>
													<span
														class="d-block p-1 px-2 pb-0 bg-soft-primary"
													></span>
												</span>
											</span>
											<span class="flex-grow-1">
												<span
													class="d-flex h-100 flex-column"
												>
													<span
														class="bg-light d-block p-1"
													></span>
													<span
														class="bg-light d-block p-1 mt-auto"
													></span>
												</span>
											</span>
										</span>
									</label>
								</div>
								<h5 class="fs-13 text-center mt-2">Light</h5>
							</div>
							<div class="col-4">
								<div
									class="form-check sidebar-setting card-radio"
								>
									<input
										class="form-check-input"
										type="radio"
										name="data-sidebar"
										id="sidebar-color-dark"
										value="dark"
										[checked]="sidebar === 'dark'"
										onchange="document.documentElement.setAttribute('data-sidebar', 'dark')"
										(click)="removeActive()"
									/>
									<label
										class="form-check-label p-0 avatar-md w-100"
										for="sidebar-color-dark"
									>
										<span class="d-flex gap-1 h-100">
											<span class="flex-shrink-0">
												<span
													class="bg-primary d-flex h-100 flex-column gap-1 p-1"
												>
													<span
														class="d-block p-1 px-2 bg-soft-light rounded mb-2"
													></span>
													<span
														class="d-block p-1 px-2 pb-0 bg-soft-light"
													></span>
													<span
														class="d-block p-1 px-2 pb-0 bg-soft-light"
													></span>
													<span
														class="d-block p-1 px-2 pb-0 bg-soft-light"
													></span>
												</span>
											</span>
											<span class="flex-grow-1">
												<span
													class="d-flex h-100 flex-column"
												>
													<span
														class="bg-light d-block p-1"
													></span>
													<span
														class="bg-light d-block p-1 mt-auto"
													></span>
												</span>
											</span>
										</span>
									</label>
								</div>
								<h5 class="fs-13 text-center mt-2">Dark</h5>
							</div>
							<div class="col-4">
								<button
									class="btn btn-link avatar-md w-100 p-0 overflow-hidden border collapsed"
									id="collapseBgGradient1"
									type="button"
									data-bs-toggle="collapse"
									data-bs-target="#collapseBgGradient"
									aria-expanded="false"
									aria-controls="collapseBgGradient"
									(click)="addActive('gradient')"
								>
									<span class="d-flex gap-1 h-100">
										<span class="flex-shrink-0">
											<span
												class="bg-vertical-gradient d-flex h-100 flex-column gap-1 p-1"
											>
												<span
													class="d-block p-1 px-2 bg-soft-light rounded mb-2"
												></span>
												<span
													class="d-block p-1 px-2 pb-0 bg-soft-light"
												></span>
												<span
													class="d-block p-1 px-2 pb-0 bg-soft-light"
												></span>
												<span
													class="d-block p-1 px-2 pb-0 bg-soft-light"
												></span>
											</span>
										</span>
										<span class="flex-grow-1">
											<span
												class="d-flex h-100 flex-column"
											>
												<span
													class="bg-light d-block p-1"
												></span>
												<span
													class="bg-light d-block p-1 mt-auto"
												></span>
											</span>
										</span>
									</span>
								</button>
								<h5 class="fs-13 text-center mt-2">Gradient</h5>
							</div>
						</div>

						<div class="collapse" id="collapseBgGradient">
							<div
								class="d-flex gap-2 flex-wrap img-switch p-2 px-3 bg-light rounded"
							>
								<div
									class="form-check sidebar-setting card-radio"
								>
									<input
										class="form-check-input"
										type="radio"
										name="data-sidebar"
										id="sidebar-color-gradient"
										value="gradient"
										[checked]="grd === 'gradient'"
										onchange="document.documentElement.setAttribute('data-sidebar', 'gradient')"
									/>
									<label
										class="form-check-label p-0 avatar-xs rounded-circle"
										for="sidebar-color-gradient"
									>
										<span
											class="avatar-title rounded-circle bg-vertical-gradient"
										></span>
									</label>
								</div>
								<div
									class="form-check sidebar-setting card-radio"
								>
									<input
										class="form-check-input"
										type="radio"
										name="data-sidebar"
										id="sidebar-color-gradient-2"
										value="gradient-2"
										[checked]="sidebar === 'gradient'"
										onchange="document.documentElement.setAttribute('data-sidebar', 'gradient-2')"
									/>
									<label
										class="form-check-label p-0 avatar-xs rounded-circle"
										for="sidebar-color-gradient-2"
									>
										<span
											class="avatar-title rounded-circle bg-vertical-gradient-2"
										></span>
									</label>
								</div>
								<div
									class="form-check sidebar-setting card-radio"
								>
									<input
										class="form-check-input"
										type="radio"
										name="data-sidebar"
										id="sidebar-color-gradient-3"
										value="gradient-3"
										[checked]="sidebar === 'gradient'"
										onchange="document.documentElement.setAttribute('data-sidebar', 'gradient-3')"
									/>
									<label
										class="form-check-label p-0 avatar-xs rounded-circle"
										for="sidebar-color-gradient-3"
									>
										<span
											class="avatar-title rounded-circle bg-vertical-gradient-3"
										></span>
									</label>
								</div>
								<div
									class="form-check sidebar-setting card-radio"
								>
									<input
										class="form-check-input"
										type="radio"
										name="data-sidebar"
										id="sidebar-color-gradient-4"
										value="gradient-4"
										[checked]="sidebar === 'gradient'"
										onchange="document.documentElement.setAttribute('data-sidebar', 'gradient-4')"
									/>
									<label
										class="form-check-label p-0 avatar-xs rounded-circle"
										for="sidebar-color-gradient-4"
									>
										<span
											class="avatar-title rounded-circle bg-vertical-gradient-4"
										></span>
									</label>
								</div>
							</div>
						</div>

						<div id="sidebar-img">
							<h6 class="mt-4 mb-0 fw-semibold text-uppercase">
								Sidebar Images
							</h6>
							<p class="text-muted">Choose a image of Sidebar.</p>

							<div class="d-flex gap-2 flex-wrap img-switch">
								<div
									class="form-check sidebar-setting card-radio"
								>
									<input
										class="form-check-input"
										type="radio"
										name="data-sidebar-image"
										id="sidebarimg-none"
										value="none"
										[checked]="sidebarImage === 'none'"
										onchange="document.documentElement.setAttribute('data-sidebar-image', 'none')"
									/>
									<label
										class="form-check-label p-0 avatar-sm h-auto"
										for="sidebarimg-none"
									>
										<span
											class="avatar-md w-auto bg-light d-flex align-items-center justify-content-center"
										>
											<i class="ri-close-fill fs-20"></i>
										</span>
									</label>
								</div>

								<div
									class="form-check sidebar-setting card-radio"
								>
									<input
										class="form-check-input"
										type="radio"
										name="data-sidebar-image"
										id="sidebarimg-01"
										value="img-1"
										[checked]="sidebarImage === 'img-1'"
										onchange="document.documentElement.setAttribute('data-sidebar-image', 'img-1')"
									/>
									<label
										class="form-check-label p-0 avatar-sm h-auto"
										for="sidebarimg-01"
									>
										<img
											src="assets/images/sidebar/img-1.jpg"
											alt=""
											class="avatar-md w-auto object-cover"
										/>
									</label>
								</div>

								<div
									class="form-check sidebar-setting card-radio"
								>
									<input
										class="form-check-input"
										type="radio"
										name="data-sidebar-image"
										id="sidebarimg-02"
										value="img-2"
										[checked]="sidebarImage === 'img-2'"
										onchange="document.documentElement.setAttribute('data-sidebar-image', 'img-2')"
									/>
									<label
										class="form-check-label p-0 avatar-sm h-auto"
										for="sidebarimg-02"
									>
										<img
											src="assets/images/sidebar/img-2.jpg"
											alt=""
											class="avatar-md w-auto object-cover"
										/>
									</label>
								</div>
								<div
									class="form-check sidebar-setting card-radio"
								>
									<input
										class="form-check-input"
										type="radio"
										name="data-sidebar-image"
										id="sidebarimg-03"
										value="img-3"
										[checked]="sidebarImage === 'img-3'"
										onchange="document.documentElement.setAttribute('data-sidebar-image', 'img-3')"
									/>
									<label
										class="form-check-label p-0 avatar-sm h-auto"
										for="sidebarimg-03"
									>
										<img
											src="assets/images/sidebar/img-3.jpg"
											alt=""
											class="avatar-md w-auto object-cover"
										/>
									</label>
								</div>
								<div
									class="form-check sidebar-setting card-radio"
								>
									<input
										class="form-check-input"
										type="radio"
										name="data-sidebar-image"
										id="sidebarimg-04"
										value="img-4"
										[checked]="sidebarImage === 'img-4'"
										onchange="document.documentElement.setAttribute('data-sidebar-image', 'img-4')"
									/>
									<label
										class="form-check-label p-0 avatar-sm h-auto"
										for="sidebarimg-04"
									>
										<img
											src="assets/images/sidebar/img-4.jpg"
											alt=""
											class="avatar-md w-auto object-cover"
										/>
									</label>
								</div>
							</div>
						</div>
					</div>
				</ng-template>
			</div>
		</ngx-simplebar>
	</div>
</div>
